import React 			from 'react';
import BLComponent 		from '../core/_BLComponent.jsx';

import SearchListingItem from '../common/_SearchListingItem.jsx';
import EmptyState from '../common/_EmptyState.jsx';

export default class SearchModalContent extends BLComponent
{
	constructor(props) 
	{
		super(props);

		this.state = 
			{
				searchQuery: 	''
			,	results:		[]
			};

		this.funcQuery	= _.debounce( ( q ) => this.fetchResult( q ), 200 );
	}

	componentDidMount() 
	{
		blapp.models.fetch(
			"recent_list"
		,	{
				controller:	"common.BLCRecentVisitedItem"
			,	method:		"getRecentlyViewedCatalogItem"
			,	params:		[]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				let		result	= [];
				
				_.forEach( 
					data
				,	( item ) =>
					{
						if ( item.dmItemView && item.dmItemView.dmItem.typeItem == "S" )
						{
							result.push( item.dmItemView.dmItem );
						}
					}
				);

				this.recentViews	= result;
				this.setState( { results: result } );				
			}
		).catch(
			( err ) =>
			{
			}
		)
	}


	render() 
	{
		const typeItem = this.props.type;

		return (
			<div className="modal set-search-modal modal--medium">
				<div className="modal__overlay" onClick={() => this.props.closeFunc()}></div>
				<div className="modal__content set-search-modal__content">
					<div className="modal__header bg-color--cloud">
						<div className="modal__title">{`Find ${typeItem} in a set`}</div>
						<i className="far fa-times modal__close" onClick={() => this.props.closeFunc()}></i>
					</div>
					{this.renderSearchBar()}
					<div className="modal__body l-pad--null set-search-modal__items">
						{!this.state.searchQuery.length && this.state.results ? <div className="main-nav-sub__section-title text--bold text--small l-margin--null">Top searches</div> : null}
						{this.renderResults()}
					</div>
				</div>
			</div>
		);
	}

	renderSearchBar() 
	{
		const {type} = this.props;

		return (
			<div className="set-search-modal__search-bar search-lockup bg-color--darkestBlue l-pad">
				<div className="search-lockup__input-container">
					<input type="text" className="search-lockup__input search-lockup__input--start l-pad-left" placeholder={`Enter set ID or name`} value={this.state.searchQuery} onChange={(e) => this.updateQuery(e.target.value)}/>
					{this.state.searchQuery.length ? <button className="btn btn--blank search-lockup__btn--clear" onClick={() => this.updateQuery( '' )}><i className="fas fa-times-circle"/></button> : null}
				</div>
				<button className="search-lockup__btn search-lockup__btn--end bg-color--primaryYellow"><i className="far fa-search search-lockup__btn-icon"/></button>
			</div>
		);
	}

	renderResults() 
	{
		if ( !_.isEmpty( this.state.results ) )
		{
			return (
				<ul className="l-pad-x">
				{
					_.map(
						this.state.results
					,	( item ) =>
						{
							return ( 
								<SearchListingItem item={{name: item.strItemName, url: blapp.url2.getCatalogItemInventoryUrl( item ), image: blapp.url2.getCatalogItemImgUrl( item.imgDefault, "T1" )}}/>
							);
						}
					)
				}
				</ul>
			);
		}else{
			return (
				<EmptyState type="scared" message={`No sets found that match "${this.state.searchQuery}".`} classes="text--center"/>
			);
		}
	}

	updateQuery( newQuery )
	{
		newQuery	= newQuery.trimStart();

		if ( newQuery != this.state.searchQuery )
		{
			if ( newQuery == "" && !_.isEmpty( this.recentViews ) )
			{
				this.setState( { searchQuery: "", results: this.recentViews } );
			}
			else
			{
				this.setState( { searchQuery: newQuery } );
				this.funcQuery( newQuery );
			}
		}
	}

	fetchResult( newQuery )
	{
		blapp.models.fetch(
			"searchResults"
		,	{
				controller:	"search.BLCSearch"
			,	method:		"searchCatalogItemBasicWithDataTop100"
			,	params:		[ newQuery, "S" ]
			,	refresh:	true
			}
		).then(
			( data ) =>
			{
				this.setState( { results: data.length > 10 ? data.slice( 0, 10 ) : data } );
			}
		);
	}

	gotoItem( item )
	{
		if ( item )
			window.location.href	= blapp.url2.getCatalogItemPageUrl( item );
	}

}